
const PEXELS_API_KEY = import.meta.env.VITE_PEXELS_API_KEY;

export const fetchRandomSoccerImage = async (query: string = "soccer"): Promise<string | null> => {
    try {
        const url = `https://api.pexels.com/v1/search?query=${encodeURIComponent(query)}&per_page=15&orientation=landscape`;
        const response = await fetch(url, {
            headers: {
                Authorization: PEXELS_API_KEY
            }
        });

        if (!response.ok) throw new Error("Pexels API Error");
        const data = await response.json();
        
        if (data.photos && data.photos.length > 0) {
            const randomIndex = Math.floor(Math.random() * data.photos.length);
            return data.photos[randomIndex].src.original;
        }
        return null;
    } catch (error) {
        console.error("Failed to fetch image from Pexels", error);
        return null;
    }
};

/**
 * Pexels API에서 특정 쿼리에 맞는 이미지 리스트를 가져옵니다. (페이지네이션 지원)
 */
export const fetchPexelsImages = async (query: string = "soccer", perPage: number = 10, page: number = 1): Promise<{ photos: any[], total_results: number }> => {
    try {
        const url = `https://api.pexels.com/v1/search?query=${encodeURIComponent(query)}&per_page=${perPage}&page=${page}&orientation=landscape`;
        const response = await fetch(url, {
            headers: {
                Authorization: PEXELS_API_KEY
            }
        });

        if (!response.ok) throw new Error("Pexels API Error");
        const data = await response.json();
        
        return {
            photos: data.photos || [],
            total_results: data.total_results || 0
        };
    } catch (error) {
        console.error("Failed to fetch images from Pexels", error);
        return { photos: [], total_results: 0 };
    }
};
